import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  spacer: {
    flex: 1,
  },
})

export const apartmentHasChoices = [
  { id: 'balcony_terrace', name: 'Balcony' },
  { id: 'elevator', name: 'Elevator' },
  { id: 'car_parking', name: 'Car Parking' },
  { id: 'living_room', name: 'Living Room' },
  { id: 'garden', name: 'Garden' },
]

export const furnitureChoices = [
  { id: 'Lavatrice', name: 'Washing machine' },
  { id: 'Lavastoviglie', name: 'Dishwasher' },
  { id: 'Aria condizionata', name: 'Air-conditioning' },
  { id: 'TV', name: 'TV' },
  { id: 'Forno', name: 'Oven' },
  { id: 'Microonde', name: 'Microwave' },
  { id: 'Matrimoniale', name: 'Double bed' },
  { id: 'Armadio', name: 'Wardrobe' },
  { id: 'Scrivania', name: 'Desk' },
]

export const propertyTypeCoices = [
  { id: 'Entire Property', name: 'Entire Property' },
  { id: 'Private Room', name: 'Private Room' },
  { id: 'Shared Room', name: 'Shared Room' },
  { id: 'Studio', name: 'Studio' },
]

export const propertyStatusChoiches = [
  { id: 'draft', name: 'draft' },
  { id: 'pending', name: 'pending' },
  { id: 'disabled', name: 'disabled' },
  { id: 'deleted', name: 'deleted' },
  { id: 'active', name: 'active' },
]

export const includedCostChoices = [
  { id: 'water', name: 'Water' },
  { id: 'garbage', name: 'Garbage' },
  { id: 'condominio', name: 'Condominio' },
  { id: 'gas', name: 'Gas' },
  { id: 'internet', name: 'Internet' },
  { id: 'electricity', name: 'Electricity' },
]

export const bathroomTypeChoices = [
  { id: 'Shared', name: 'Shared' },
  { id: 'Private', name: 'Private' },
]

export const depositChoices = [
  { id: '0', name: 'No Deposit' },
  { id: '0.5', name: '0.5 month' },
  { id: '1', name: '1 Month' },
  { id: '2', name: '2 Months' },
  { id: '3', name: '3 Months' },
]

export const houseForChoices = [
  { id: 'male', name: 'Male' },
  { id: 'female', name: 'Female' },
  { id: 'any', name: 'Any' },
]

export const floorChoices = [
  { id: '-1', name: '-1' },
  { id: '0', name: '0' },
  { id: '1', name: '1' },
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' },
  { id: 'Last', name: 'Last' },
  { id: 'More Floors', name: 'More Floors' },
]
